<template>
  <div class="thx-backdrop" aria-hidden="true" />
</template>

<style scoped>
.thx-backdrop {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(ellipse at 50% 45%, rgb(255 40 40 / 28%), transparent 65%),
    radial-gradient(ellipse at 50% 120%, rgb(0 0 0 / 55%), transparent 60%);
}
</style>
